import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TransformDreamsIntoPaper from "./sections/TransformDreamsIntoPaper";
import ModCategories from "./sections/ModCategories";
import RecienSalidoDelHorno from "./sections/RecienSalidoDelHorno";
import TeknikServisVeBakimHizmetleri from "./sections/TeknikServisVeBakimHizmetleri";
import WhyChooseUs from "./sections/WhyChooseUs";
import FooterInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TransformDreamsIntoPaper />
      <ModCategories />
      <RecienSalidoDelHorno />
      <TeknikServisVeBakimHizmetleri />
      <WhyChooseUs />
      <FooterInfo />
    </div>;
}